var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-miterlimit:1;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.5,31.5h-21c-2.8,0-5-2.3-5-5v-21c0-2.8,2.3-5,5-5h21c2.8,0,5,2.3,5,5v21C31.5,29.3,29.3,31.5,26.5,31.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1,6.2c-0.3-0.3-0.8-0.3-1.2-0.1l-25,12.3c-0.5,0.2-0.8,0.7-0.8,1.2c0,0.5,0.3,0.9,0.8,1.1l3.9,1.5 c0.5,0.2,1.1,0.1,1.6-0.2l3.6-2.3c0.4-0.2,0.8,0.2,0.5,0.5l-2.2,2c-0.4,0.3-0.5,0.7-0.5,1.2l0.6,3.6c0.1,0.4,0.4,0.7,0.8,0.8 c0.4,0.1,0.9,0,1.3-0.2l2.4-1.9c0.1-0.1,0.3-0.1,0.4-0.1l2.8,1.1c0.3,0.1,0.6,0.1,0.9,0.1c0.1,0,0.2,0,0.3-0.1 c0.4-0.1,0.7-0.4,0.9-0.7l9.3-18.8C29.6,6.8,29.5,6.4,29.1,6.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.079d86b8b44d1eb97adfc6447ec9cd6f.svg";
export { ForwardRef as ReactComponent };